import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';
import { GanttChartControlComponent } from '../gantt-chart-control/gantt-chart-control.component';
import { summaryInfo } from '../issue-management/issue-management.component';
import { IssueInfo } from '../model/issue.model';
import { environment } from 'src/environments/environment';
import { ProjectProgressInfo } from '../model/ProjectProgress.model';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';


@Component({
  selector: 'app-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: ['./report-detail.component.css']
})
export class ReportDetailComponent implements OnInit {
  @ViewChild(GanttChartControlComponent) ganttchart;

  baseurl: string;

  //Popup show result
  ResultHeader: string;
  ResultText: string;
  _ForK2: string;
  _EmpCode: string;
  _CompanyCode: string;
  _ParamCompanyCode: string;
  _CompanyName: string;
  _ParamCompanyName: string;
  _ProjectCode: string
  _ProjectName: string
  _ParamProjectCode: string
  _ParamProjectName: string

  _EmpRole: string;

  //Timeline
  inlineCheckboxBaselinePlan: boolean
  inlineCheckboxActualPlan: boolean
  SelectPlan: string = 'baseline,actual,';

  //Pie chart
  IssuePromise: Promise<IssueInfo[]>
  summaryInfo = new summaryInfo;
  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = false;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };

  //Progress
  hdfProgressId: number;
  sProjectProgress: string = "0";
  ProjectProgress: number;
  ProjectProgressInfo = new ProjectProgressInfo;
  ProjectSummary: string;
  ProjectCompleted: string;
  ProjectOnGoing: string;
  ProjectUpComing: string;

  //IssueType
  ProjectRiskListAll = [];
  ProjectRiskList = [];
  ProjectRiskTotal: number;
  ProjectCRListAll = [];
  ProjectCRList = [];
  ProjectCRTotal: number;

  //Pagination variable
  public risk_currentPageNumber: number = 0;
  public risk_totalPages: number
  public cr_currentPageNumber: number = 0;
  public cr_totalPages: number
  public environment: number
  riskIdx: number = 0;
  crIdx: number = 0;
  /************************************ Variables **************************************************/

  /************************************ Initial Function *******************************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private elementRef: ElementRef, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    this._ParamCompanyCode = this.activatedRoute.snapshot.params.CompanyCode;
    this._ParamCompanyName = this.activatedRoute.snapshot.params.CompanyName;
    this._ProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
    this._ProjectName = this.activatedRoute.snapshot.params.ProjectName;
  }

  async ngOnInit() {
    this.risk_currentPageNumber = 0;
    this.cr_currentPageNumber = 0;
    this.environment = environment.PageSizeSmall;

    if (this._EmpCode == '' || this._EmpCode == null) this._EmpCode = localStorage.getItem("EmpCode");

    this._CompanyCode = !!this._ParamCompanyCode ? this._ParamCompanyCode : localStorage.getItem("CompanyCode");
    this._CompanyName = !!this._ParamCompanyName ? this._ParamCompanyName : localStorage.getItem("CompanyName");
    this._ParamProjectCode = !!this._ProjectCode ? this._ProjectCode : this.GetParam('ProjectCode').toString();
    this._ParamProjectName = !!this._ProjectName ? this._ProjectName.replace(/%20/g, " ") : this.GetParam('ProjectName').toString().replace(/%20/g, " ");

    this._EmpRole = localStorage.getItem("EmpRoleCode");

    this.inlineCheckboxBaselinePlan = true;
    this.inlineCheckboxActualPlan = true;

    await this.LoadIssueAll();
    await this.LoadProjectProgress();
  }

  LoadIssueAll() {
    this.LoadIssueList(true)
      .then(
        data => {

          /*** Issue Type ***/
          this.ProjectRiskListAll = data.filter(x => !!x.IssueTypeCode && x.IssueTypeCode == "4");//risk = 4
          this.ProjectRiskTotal = this.ProjectRiskListAll.length;
          this.ProjectCRListAll = data.filter(x => !!x.IssueTypeCode && x.IssueTypeCode == "1");//cr =1
          this.ProjectCRTotal = this.ProjectCRListAll.length;
          this.OnLoadCountDocumentList();

          //Summary priority / severity
          this.summaryInfo.sumPriorityL = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low").length;
          this.summaryInfo.sumPriorityM = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium").length;
          this.summaryInfo.sumPriorityH = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High").length;
          this.summaryInfo.sumPriorityNotSet = data.filter(x => x.IssueStatusName != "Closed" && (x.PriorityName == "" || x.PriorityName == null)).length;

          this.summaryInfo.sumSeverityL = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Minor").length;
          this.summaryInfo.sumSeverityM = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Major").length;
          this.summaryInfo.sumSeverityH = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Critical").length;
          this.summaryInfo.sumSeverityNotSet = data.filter(x => x.IssueStatusName != "Closed" && (x.SeverityName == "" || x.SeverityName == null)).length;

          this.summaryInfo.PriorityLList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low");
          this.summaryInfo.PriorityMList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium");
          this.summaryInfo.PriorityHList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High");

          this.summaryInfo.SeverityLList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Minor");
          this.summaryInfo.SeverityMList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Major");
          this.summaryInfo.SeverityHList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Critical");

          this.summaryInfo.sumPriorityLList = this.GroupAndSumStatusIssue(this.summaryInfo.PriorityLList);
          this.summaryInfo.sumPriorityMList = this.GroupAndSumStatusIssue(this.summaryInfo.PriorityMList);
          this.summaryInfo.sumPriorityHList = this.GroupAndSumStatusIssue(this.summaryInfo.PriorityHList);
          
          if (this.summaryInfo.sumPriorityHList.length == 0) {
            this.summaryInfo.sumPriorityHList = this.summaryInfo.sumPriorityMList;
            if (this.summaryInfo.sumPriorityMList.length == 0) {
              this.summaryInfo.sumPriorityHList = this.summaryInfo.sumPriorityLList
            }
          }
          

          this.summaryInfo.sumSeverityLList = this.GroupAndSumStatusIssue(this.summaryInfo.SeverityLList);
          this.summaryInfo.sumSeverityMList = this.GroupAndSumStatusIssue(this.summaryInfo.SeverityMList);
          this.summaryInfo.sumSeverityHList = this.GroupAndSumStatusIssue(this.summaryInfo.SeverityHList);
          if (this.summaryInfo.sumSeverityHList.length == 0) {
            this.summaryInfo.sumSeverityHList = this.summaryInfo.sumSeverityMList;
            if (this.summaryInfo.sumSeverityHList.length == 0) {
              this.summaryInfo.sumSeverityHList = this.summaryInfo.sumSeverityLList;
            }
          }

          //Summary project type
          this.summaryInfo.sumStatusOpen = data.filter(x => x.IssueStatusName == "Open").length;
          this.summaryInfo.sumStatusInprogress = data.filter(x => x.IssueStatusName == "In Progress").length;
          this.summaryInfo.sumStatusClosed = data.filter(x => x.IssueStatusName == "Closed").length;
          this.summaryInfo.sumStatusNew = data.filter(x => x.IssueStatusName == "New").length;
          this.summaryInfo.sumStatusHold = data.filter(x => x.IssueStatusName == "Hold").length;

          this.pieChartLabels = ['Open', 'In Progress', 'Hold', 'Closed']
          this.pieChartData = [this.summaryInfo.sumStatusOpen, this.summaryInfo.sumStatusInprogress, this.summaryInfo.sumStatusHold, this.summaryInfo.sumStatusClosed];
          this.pieChartColors[0].backgroundColor = ['#6ae7d8', '#e8a362', '#6a8fef', '#5f5e5e'];
        }
      )
  }
  async LoadIssueList(Getall: boolean = false): Promise<IssueInfo[]> {

    // Update variable for pagination from pagination control
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['FlagDelete'] = "N";

      if (Getall == true) {
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;

      }

      let strjson = JSON.stringify(objectjson);

      this.IssuePromise = this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetIssueCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.IssuePromise;
    }
  }

  async LoadProjectProgress() {
    //Set post param
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ProjectProgressInfo[]>(this.baseurl + "ProjectProgress/GetProjectProgress",
          strjson, httpOptions)
        .toPromise().then(
          data => {
            if (data.length > 0) {

              this.ProjectProgressInfo = data[0];
              this.hdfProgressId = data[0].Id;
              this.sProjectProgress = this.ProjectProgressInfo.ProjectProgress.toString();
              this.ProjectProgress = this.ProjectProgressInfo.ProjectProgress;
              this.ProjectSummary = data[0].ProjectSummary;
              this.ProjectCompleted = data[0].ProjectCompleted;
              this.ProjectOnGoing = data[0].ProjectOnGoing;
              this.ProjectUpComing = data[0].ProjectUpComing;

            } else {

              this.hdfProgressId = 0;
              this.sProjectProgress = "0";
              this.ProjectProgress = 0;
              this.ProjectProgressInfo.ProjectSummary = "-";
              this.ProjectProgressInfo.ProjectCompleted = "-";
              this.ProjectProgressInfo.ProjectOnGoing = "-";
              this.ProjectProgressInfo.ProjectUpComing = "-";
              this.ProjectSummary = "";
              this.ProjectCompleted = "";
              this.ProjectOnGoing = "";
              this.ProjectUpComing = "";

            }

            this.InitProgressBar();
          }
        )
    }
  }

  LoadRiskIssue()
  {
    var offset = (this.risk_currentPageNumber - 1) * environment.PageSizeSmall;
    this.ProjectRiskList = this.ProjectRiskListAll.slice(offset, offset + environment.PageSizeSmall)
  }
  LoadCRIssue() {
    var offset = (this.cr_currentPageNumber - 1) * environment.PageSizeSmall;
    this.ProjectCRList = this.ProjectCRListAll.slice(offset, offset + environment.PageSizeSmall)
  }
  /************************************ Function *******************************************/
  OnSelectedTabChange(traget) {
    this.LoadIssueAll();
    this.LoadProjectProgress();
  }

  OnCheckboxPlanOnChange() {
    var checkbaseline = this.inlineCheckboxBaselinePlan;
    if (checkbaseline == true) {
      this.SelectPlan += 'baseline,';
    } else {
      this.SelectPlan = this.SelectPlan.replace(new RegExp('baseline,', 'g'), '');
    }
    var checkboxactual = this.inlineCheckboxActualPlan;
    if (checkboxactual == true) {
      this.SelectPlan += 'actual,';
    } else {
      this.SelectPlan = this.SelectPlan.replace(new RegExp('actual,', 'g'), '');
    }
    this.ganttchart.OnloadBaseline(false, this.SelectPlan);

  }

  OnChartClicked(traget) {

  }

  async OnSaveClick() {
    var IsSuccess = false;
    if (this.hdfProgressId > 0) {
      //Update
      IsSuccess = await this.UpdateProjectProgress();
      
    } else {
      //Insert
      IsSuccess = await this.InsertProjectProgress();
      
    }

    this.ResultHeader = IsSuccess ? "Success" : "Sorry!";
    this.ResultText = IsSuccess ? "Your project progress was updated successfully" : "Updating fail.";
    $("#ModalResult").modal();
    
  }

  async UpdateProjectProgress() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['ProjectProgress'] = this.ProjectProgress;
      objectjson['ProjectSummary'] = this.ProjectSummary;
      objectjson['ProjectCompleted'] = this.ProjectCompleted;
      objectjson['ProjectOnGoing'] = this.ProjectOnGoing;
      objectjson['ProjectUpComing'] = this.ProjectUpComing;
      objectjson['UpdateBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      var IsSuccess = true;
      await this.httpClient
        .post<boolean>(this.baseurl + "ProjectProgress/UpdateProjectProgress",
          strjson, httpOptions)
        .toPromise().then(
          data => {

            IsSuccess = data;
          }
        ).catch(err => {
          IsSuccess = false;
        });

      return IsSuccess;
    }
  }

  async InsertProjectProgress() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['ProjectProgress'] = this.ProjectProgress;
      objectjson['ProjectSummary'] = this.ProjectSummary;
      objectjson['ProjectCompleted'] = this.ProjectCompleted;
      objectjson['ProjectOnGoing'] = this.ProjectOnGoing;
      objectjson['ProjectUpComing'] = this.ProjectUpComing;
      objectjson['CreateBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      var IsSuccess = true;
      await this.httpClient
        .post<boolean>(this.baseurl + "ProjectProgress/InsertProjectProgress",
          strjson, httpOptions)
        .toPromise().then(
          data => {

            IsSuccess = data;
          }
        ).catch(err => {
          IsSuccess = false;
        });

      return IsSuccess;
    }
  }
  /************************************ End Function *******************************************/

  /************************************ Private Function *******************************************/
  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  InitProgressBar() {
    var that = this;

    $(".progress-semi-circle").each(function () {

      var $bar = $(this).find(".bar-semi-circle");
      var $val = $(this).find("span.progress-value");
      var perc = parseInt(that.sProjectProgress, 10);

      $({ p: 0 }).animate({ p: perc }, {
        duration: 1500,
        easing: "swing",
        step: function (p) {
          $bar.css({
            transform: "rotate(" + (45 + (p * 1.8)) + "deg)", // 100%=180° so: ° = % * 1.8
            // 45 is to add the needed rotation to have the green borders at the bottom
          });
          $val.text(p | 0);
        }
      });
    });


  }

  GroupAndSumStatusIssue(list) {
    var result = [];
    list.reduce(function (res, value) {
      if (!res[value.IssueOwnerCode]) {
        res[value.IssueOwnerCode] = {
          ActionOwner: value.IssueOwnerName, IssueOwnerCode: value.IssueOwnerCode,IssueOwnerNickName: value.IssueOwnerNickName, IssueAmount: 0, PriorityHigh: 0, PriorityMedium: 0, PriorityLow: 0, PriorityUndefined: 0, SeverityHigh: 0, SeverityMedium: 0, SeverityLow: 0, SeverityUndefined: 0};
        result.push(res[value.IssueOwnerCode])
      }
      res[value.IssueOwnerCode].IssueAmount += 1;

      if (value.PriorityCode == "1") {
        res[value.IssueOwnerCode].PriorityLow += 1;
      }
      if (value.PriorityCode == "2") {
        res[value.IssueOwnerCode].PriorityMedium += 1;
      }
      if (value.PriorityCode == "3") {
        res[value.IssueOwnerCode].PriorityHigh += 1;
      }
      if (value.SeverityCode == "1") {
        res[value.IssueOwnerCode].SeverityLow += 1;
      }
      if (value.SeverityCode == "2") {
        res[value.IssueOwnerCode].SeverityMedium += 1;
      }
      if (value.SeverityCode == "3") {
        res[value.IssueOwnerCode].SeverityHigh += 1;
      }

      if (!value.PriorityCode) {
        res[value.IssueOwnerCode].PriorityUndefined += 1
      }
      if (!value.SeverityCode) {
        res[value.IssueOwnerCode].SeverityUndefined += 1
      }
      return res;
    }, {});

    return result;
  }

  //For Pagination
  LoadRiskListPagination(traget) {
    this.risk_currentPageNumber = traget.currentPageNumber;
    this.risk_totalPages = traget.totalPages;
  }

  OnLoadRiskListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadRiskListPagination(traget);
      
      this.riskIdx = traget.index;
    }
    this.LoadRiskIssue();
  }

  LoadCRListPagination(traget) {
    this.cr_currentPageNumber = traget.currentPageNumber;
    this.cr_totalPages = traget.totalPages;
  }

  OnLoadCRListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadCRListPagination(traget);
      
      this.crIdx = traget.index;
    }
    this.LoadCRIssue();
  }

  OnLoadCountDocumentList() {
    //call function load count all ticket list on hand current role user
    this.risk_totalPages = Math.ceil(this.ProjectRiskTotal / environment.PageSizeSmall);
    this.risk_currentPageNumber = this.risk_totalPages > 0 ? 1 : this.risk_totalPages;
    this.LoadRiskIssue();
    
    this.cr_totalPages = Math.ceil(this.ProjectCRTotal / environment.PageSizeSmall);
    this.cr_currentPageNumber = this.cr_totalPages > 0 ? 1 : this.cr_totalPages;
    this.LoadCRIssue();
  }
  /************************************ End Private Function *******************************************/
}
